import { render, staticRenderFns } from "./NoveltyFormComponent.vue?vue&type=template&id=356c9490"
import script from "./NoveltyFormComponent.vue?vue&type=script&lang=js"
export * from "./NoveltyFormComponent.vue?vue&type=script&lang=js"
import style0 from "./NoveltyFormComponent.vue?vue&type=style&index=0&id=356c9490&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports